import LinkButton from "ds/components/Button/LinkButton";
import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import useMaintenanceStore from "shared/Maintenance/store";
import useScheduledMaintenance from "shared/Maintenance/useScheduled";

const ScheduledMaintenanceCallout = () => {
  const isMaintenanceActive = useMaintenanceStore((state) => state.enabled);
  const notice = useScheduledMaintenance();

  if (isMaintenanceActive || !notice) return null;

  return (
    <Callout
      variant="info"
      title={notice.title}
      storageKey={`maintenance:${notice.id}:${notice.updatedAt}`}
    >
      {notice.body}
      <FeedbackActions>
        <LinkButton
          variant="contrast"
          size="small"
          href={notice.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          View status page
        </LinkButton>
      </FeedbackActions>
    </Callout>
  );
};

export default ScheduledMaintenanceCallout;
